import Style from '../css/style.css';

document.onreadystatechange = function () {
	'use strict';

	function showOverlay() {
		var overlay = document.createElement("DIV");
		document.body.insertBefore(overlay, document.body.childNodes[0]);
		overlay.classList.add('overlay');
		document.body.style.overflow = 'hidden';
	}

	function hideOverlay() {
		var overlay = document.querySelector('.overlay');
		overlay.remove();
		document.body.style.overflowY = 'auto';
	}

	function addElement(dataName, dataObj, ind, param) {
		if (dataName == 'head') {
			return (`
				<div class="modal-head">
            		<h2>` + param + `</h2>
         		</div>
			`);
		}
		if (dataName == 'foot') {
			if (param) {
				return (
					`<div class="modal-foot">
					  <a class="btn btn-blue" target="_blank" href="` + param + `">View Demo</a>
					  <button class="btn btn-red modal-close">Close</button>
					</div>`
				);
			} else {
				return (
					`<div class="modal-foot">
					  <button class="btn btn-red modal-close">Close</button>
					</div>`
				);
			}
		}
	}

	function gitData(data) {
		return (`
			<div class="col-6">
				<img class="img-fluid" src="${ data.avatar_url }" />
			</div>
			<div class="col-6">
				<div class="card-heading">${ data.name }</div>
				<p class="mb-10">Title : <span style="color: black">${ data.bio }</span></p>
				<p class="mb-10">Repositories : <span style="color: black">${ data.public_repos }</span></p>
				<p class="mb-10">Gists : <span style="color: black">${ data.public_gists }</span></p>
				<p class="mb-10">Followers : <span style="color: black">${ data.followers }</span></p>
				<p class="mb-10">Following : <span style="color: black">${ data.following }</span></p>
				<Button class="btn btn-red" style="margin: 0px;" onClick="window.open('${ data.html_url }', '_blank')">View Profile</button>
			</div>
		`);
	}
	
	function stackData(data) {
		return (`
			<div class="col-12">
				<div class="card-heading">StackExchange Data</div>
				<div class="mb-10 well">
					${ data.items[0].site_name } : <span style="color: black">${ data.items[0].reputation } Reputation</span>
					<div>Gold: <span style="color: #ffc107;">${ data.items[0].badge_counts.gold }</span>, Silver: <span style="color: #bdbdbd;">${ data.items[0].badge_counts.silver }</span>, Bronze: <span style="color: #cd7f32;">${ data.items[0].badge_counts.bronze }</span></div>
				</div>
				<div class="mb-10 well">
					${ data.items[6].site_name } : <span style="color: black">${ data.items[6].reputation } Reputation</span>
					<div>Gold: <span style="color: #ffc107;">${ data.items[6].badge_counts.gold }</span>, Silver: <span style="color: #bdbdbd;">${ data.items[6].badge_counts.silver }</span>, Bronze: <span style="color: #cd7f32;">${ data.items[6].badge_counts.bronze }</span></div>
				</div>
				<div class="mb-10 well">
					${ data.items[8].site_name } : <span style="color: black">${ data.items[8].reputation } Reputation</span>
					<div>Gold: <span style="color: #ffc107;">${ data.items[8].badge_counts.gold }</span>, Silver: <span style="color: #bdbdbd;">${ data.items[8].badge_counts.silver }</span>, Bronze: <span style="color: #cd7f32;">${ data.items[8].badge_counts.bronze }</span></div>
				</div>
			</div>
		`);
	}

	if (document.readyState === "complete") {
		var fadeUp = document.querySelectorAll(".fadeup-anim");
		var modalBtn = document.querySelectorAll('.btn-modal');
		var githubData = document.querySelector('.github-data');
		var stackexchangeData = document.querySelector('.stack-data');
		var offsetTopEl = document.querySelectorAll('.offsetTop');
		var modalClose = document.querySelector('.modal-close')
		var modal = document.querySelector('.modal-container')

		var fadeEL = document.querySelectorAll(".fadeup-anim");
		fadeEL.forEach(function (fadeEL) {
			fadeEL.style.opacity = 0;
		});

		modalClose.addEventListener('click', function (e) {
			hideOverlay();
			modal.innerHTML = '';
		})
		
		offsetTopEl.forEach(function (offsetTopEl) {
			window.addEventListener("scroll", function () {
				var windowHeight = window.innerHeight, scroll = window.scrollY;
				var eloffset = windowHeight + scroll - 100;

				if (eloffset > offsetTopEl.offsetTop) {
					if (offsetTopEl.classList.contains("fadeup-anim")) {
						if (!offsetTopEl.classList.contains("animated")) {
							offsetTopEl.classList.add("fadeUp", "animated");
						}
					} else if (offsetTopEl.classList.contains("github-data")) {
						if (!offsetTopEl.classList.contains("github-data-retrived")) {
							var git = new XMLHttpRequest();
							git.open('GET', 'https://api.github.com/users/raajnadar');
							git.onload = function () {
								var gitRetData = JSON.parse(git.responseText);
								githubData.innerHTML = gitData(gitRetData);
							}
							git.send();
							offsetTopEl.classList.add("github-data-retrived");
						}
					} else if (offsetTopEl.classList.contains("stack-data")) {
						if (!offsetTopEl.classList.contains("stack-data-retrived")) {
							var stack = new XMLHttpRequest();
							stack.open('GET', 'https://api.stackexchange.com/2.2/users/7233978/associated');
							stack.onload = function () {
								var stackRetData = JSON.parse(stack.responseText);
								stackexchangeData.innerHTML = stackData(stackRetData);
							}
							stack.send();
							offsetTopEl.classList.add("stack-data-retrived");
						}
					}
				}
			});
		});

		modalBtn.forEach(function (modalBtn) {
			modalBtn.addEventListener('click', function (e) {
				showOverlay();
				var dataName = e.target.getAttribute("data-name");
				modal = document.querySelector('.modal-container');

				var req = new XMLHttpRequest();
				req.open('GET', document.baseURI + '/project.json');
				req.onload = function () {
					var data = JSON.parse(req.responseText),
						index;

					if (modal.innerHTML === '') {
						for (var i = 0; i < data.length; i++) {
							if (data[i].id == dataName) {
								index = i;
							}
						}

						var htmlData =
							`<div class="modal">
							  ${ addElement('head', data, index, data[index].name) }
							  <div class="modal-body">
								<div class="content">
								  <div class="row">
									  <div class="col-6 col-offset-3">
										  <img class="img-fluid" alt="${ data[index].id }" src="${ data[index].thumb }" />
									  </div>
								  </div>
								  <div class="align-center">
									  <h3>${ data[index].name }</h3>
								  </div>
								  <p class="mt-10 mb-10"><span style="color: black">Author : </span><a class="link-red" href="${ data[index].author_url }">${ data[index].author }</a></p>
								  <p class="mb-10"><span style="color: black">About project : </span>${ data[index].description }</p>
								  <p><span style="color: black">Project repository: </span><a href="${ data[index].project_url }" target="_blank">${ data[index].project_url }</a></p>
								</div>
							  </div>
							  ${ addElement('foot', data, index, data[index].demo_url) }
						  </div>`;

						modal.innerHTML = htmlData;

						modalClose = document.querySelector('.modal-close');

						modalClose.addEventListener('click', function (e) {
							hideOverlay();
							modal.innerHTML = '';
						});
					}

				}
				req.send();
			});
		});

	}
};



// WEBPACK FOOTER //
// ./assets/js/index.js